import React from "react";

import { FormContext } from "../../forms";
import { PrimaryButton, SecondaryButton } from "../../simple-buttons/simple-buttons";
import { SVGSuccessIcon } from "../../svg-animated/svg-animated";
import { Box, PageActionsContainer } from "../../theme/containers";
import { PcaHeading, PcaSubHeading } from "../../theme/typography";

const loadNextPage = (context?: FormContext, value?: any) => {
    if (value && value.jumpToPage) {
        context?.gotoPage(value.jumpToPage);
    } else {
        context?.gotoNextPage();
    }
};

const JourneyCompleted = ({context, value}: {context?: FormContext, value?: any}) => {
    return (
        <div className="u-text-centre">
            <Box className="u-mx-auto">
                <SVGSuccessIcon />
            </Box>
            <PcaHeading className="u-my-6">We&apos;ve got your documents, thanks</PcaHeading>
            <PcaSubHeading>
                You can continue with your application and we&apos;ll be in touch if we need anything else.
            </PcaSubHeading>
            <PageActionsContainer className="block" id="actions">
                <SecondaryButton onClick={() => context?.gotoPreviousPage()} text="Back" />
                <PrimaryButton onClick={() => loadNextPage(context, value)} text="Next" />
            </PageActionsContainer>
        </div>
    );
}

export default JourneyCompleted;
